module.exports = __webpack_public_path__ + "img/challenges.094170e2.png";